/** 线路排班-观察模式 */
<template>
  <div id="schedulingForm">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="platform" class="grid">
        <template slot="label"><i class="el-icon-time" style="margin-right:4px"></i>专线班次管理</template>
        <schedulingPlatformTimeForm ref="schedulingPlatformTimeForm" class="platform-left"
          :style="{ width: lineInfo.schedulingType == 2 ? '70%' : '100%', 'padding-right': lineInfo.schedulingType == 2 ? '20px' : '0' }"
          :lineId="lineId" @infoUpdate="infoUpdate" @schedulingTimeUpdate="schedulingTimeUpdate" />
        <schedulingPlatformTimeDriverForm class="platform-right" v-if="lineInfo.schedulingType == 2" :lineInfo="lineInfo"
          :schedulingTime="schedulingTime" />
      </el-tab-pane>
      <el-tab-pane name="driver" class="grid">
        <template slot="label"><i class="el-icon-truck" style="margin-right:4px"></i>专线包车配置</template>
        <schedulingDriverTimeForm :lineId="lineId" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "schedulingForm",
  components: {
    schedulingPlatformTimeForm: () => import("./schedulingPlatformTimeForm.vue"),
    schedulingPlatformTimeDriverForm: () => import("./schedulingPlatformTimeDriverForm.vue"),
    schedulingDriverTimeForm: () => import("./schedulingDriverTimeForm.vue"),
  },
  data() {
    return {
      tabAction: this.$route.query.tabAction || 'platform',
      lineId: this.$route.query.lineId,
      lineInfo: [],
      schedulingTime: null,
    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() { },
  methods: {
    infoUpdate(data) {
      this.lineInfo = data;
    },
    schedulingTimeUpdate(data) {
      this.schedulingTime = data;
    }
  },
};
</script>

<style lang="less" scoped>
#schedulingForm {
  .grid {
    div {
      box-sizing: border-box;
      display: inline-block;
      vertical-align: top;
    }

    .platform-left{
      overflow: hidden;
    }

    .platform-right {
      width: 30%;
    }
  }
}
</style>
